export default "__VITE_ASSET__Dyqj5zfo__"